import { api } from '../../utils/api'

export const DoLogout = async () => await api.post(`/logout`)